import '../reports.scss'
import '../../../components/common/datatable/datatable.scss'
import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material'
import Spinner from '../../../components/common/spinner/spinner'
import { useReports } from '../../pages-hooks/useReports'
import DataExportModal from '../../../components/common/dataExport/DataExportModal'
import { useState } from 'react'
import {
  blockedUserReportDataMapper,
  blockedUserReportDataMapperForPDF,
} from '../../../components/common/dataExport/dataMappers/blockedUserReportDataMapper'
import { useSelector } from 'react-redux'
import { buildTimeStringFromTimestamp } from '../../../components/common/time/timeHelper'
import { useTranslation } from 'react-i18next'
import CustomNoRowsOverlay from '../../../components/common/datagrid/CustomNoRowsOverlay'
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined'
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined'

const BlockUnblockUserReport = ({
  page,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
  isLoading,
  setIsLoading,
  setModalOpen,
}) => {
  const { activeServices } = useSelector((state) => state.login)
  const [showDownloadModal, setShowDownloadModal] = useState(false)
  const allReports = useReports('block_unblock_user_access', setIsLoading, isLoading)
  const { t } = useTranslation(['common', 'messages'])

  return (
    <Box>
      {isLoading && <Spinner noTransform />}

      <TableContainer>
        <Box className="filter-bar">
          <Button variant="label" endIcon={<MenuOutlinedIcon />} onClick={() => setModalOpen(true)}>
            {t('common:filters')}
          </Button>
          <Box className="title">
            {activeServices?.includes('reportsitem') && allReports?.data?.length > 0 && (
              <Button
                disabled={!activeServices?.includes('reportsitem') || !allReports?.data?.length}
                onClick={() => setShowDownloadModal(true)}
                endIcon={<IosShareOutlinedIcon sx={{ fill: 'var(--lime-04)' }} />}
                variant="outlined"
              >
                {/* <DownloadIcon /> */}
                <Typography variant="title2">{t('common:exportReport')}</Typography>
              </Button>
            )}
          </Box>
        </Box>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('common:Id')}</TableCell>
              <TableCell>
                {t('common:action')} {t('common:owner')}
              </TableCell>
              <TableCell>{t('common:affectedUser')}</TableCell>
              <TableCell>{t('common:status')}</TableCell>
              <TableCell>{t('common:activity')}</TableCell>
              <TableCell>{t('common:date')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(allReports?.data) && allReports?.data?.length > 0 ? (
              allReports.data.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{row.emailUser}</TableCell>
                    <TableCell>{row.activityDetails?.userCredentials}</TableCell>
                    <TableCell>{row.activityDetails?.actionResult}</TableCell>
                    <TableCell>{row.activityDetails?.actionActivity}</TableCell>
                    <TableCell>{buildTimeStringFromTimestamp(row.createdAt)}</TableCell>
                  </TableRow>
                )
              })
            ) : (
              <Box className="table-custom-overlay">
                <CustomNoRowsOverlay />
              </Box>
            )}
          </TableBody>
        </Table>
        <TablePagination
          labelRowsPerPage={[]}
          component="div"
          count={allReports?.pagination?.totalElements || 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      <Modal open={showDownloadModal} onClose={() => setShowDownloadModal(false)}>
        <div>
          <DataExportModal
            show={showDownloadModal}
            onClose={() => setShowDownloadModal(false)}
            data={allReports?.data}
            dataMapper={blockedUserReportDataMapper}
            dataMapperForPDF={blockedUserReportDataMapperForPDF}
            fileName={'block_unblock_user_report'}
            typeDataExport={'reports'}
            keyReports={'block_unblock_user_access'}
          />
        </div>
      </Modal>
    </Box>
  )
}

export default BlockUnblockUserReport
